import { render, staticRenderFns } from "./transferAccount.vue?vue&type=template&id=318cc434"
import script from "./transferAccount.vue?vue&type=script&lang=js"
export * from "./transferAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports